// extracted by mini-css-extract-plugin
export var container = "_e4-0";
export var content = "_e4-3";
export var customerTitle = "_e4-4";
export var empty = "_e4-5";
export var gray = "_e4-6";
export var header = "_e4-7";
export var info = "_e4-8";
export var loading = "_e4-2";
export var loadingCard = "_e4-9";
export var oneLine = "_e4-a";
export var personName = "_e4-e";
export var pillContainer = "_e4-b";
export var selected = "_e4-1";
export var text = "_e4-c";
export var twoLines = "_e4-d";
export var unread = "_e4-f";
export var unreadIndicator = "_e4-g";